<style lang="scss">
$teal:      #5bb8b1;
$teal-dark: #2c7d76;
$font:      'Segoe UI', system-ui, sans-serif;

.bio-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  background: $teal-dark;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  font-family: $font;

  @media (min-width: 768px) { padding: 14px 32px; }
}

.bio-footer__back {
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, border-color 0.15s;
  font-family: $font;
  outline: none;

  &:hover { background: rgba(255,255,255,0.12); border-color: #fff; }
}

.bio-footer__next {
  height: 38px;
  padding: 0 22px;
  border-radius: 8px;
  border: none;
  background: #fff;
  color: $teal-dark;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, box-shadow 0.15s;
  font-family: $font;
  outline: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);

  &:hover { background: #e4f3f0; box-shadow: 0 4px 14px rgba(0,0,0,0.16); }
}
</style>

<template>
  <div class="bio-footer">
    <button class="bio-footer__back" @click="back()">
      <i class="fa fa-arrow-left"></i> {{ backname }}
    </button>
    <button class="bio-footer__next" @click="next()" ref="kt_submit">
      {{ btnname }} <i :class="'fa ' + nextbtnicon"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    btnname:     { type: String, default: "Next" },
    nextbtnicon: { type: String, default: "fa-arrow-right" },
    backname:    { type: String, default: "Back" },
  },
  methods: {
    next() { this.$emit("next"); },
    back() { this.$emit("back"); },
  },
};
</script>
